import PropTypes from 'prop-types';
import { useState } from 'react';
import PublicHeader from '../components/public/PublicHeader';
import PublicFooter from '../components/public/PublicFooter';
import { hasAppSessionHint } from '../config/appSessionHint';

/**
 * PublicLayout - Wrapper for unauthenticated pages.
 *
 * Responsibilities:
 * - Render PublicHeader (sticky)
 * - Render children
 * - Render PublicFooter
 *
 * Does NOT:
 * - Fetch data
 * - Include program switcher/sidebar
 * - Share styles with GlobalLayout (except base tokens)
 */
// This legacy JSX boundary receives ReactNode children from every explicit
// Marketing route; migrate it to TSX before broadening its prop surface.
const PublicLayout = ({ children }) => {
    const [hasSessionHint] = useState(hasAppSessionHint);

    return (
        <div className="min-h-screen flex flex-col bg-background">
            <a
                href="#main-content"
                className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[100] focus:rounded-md focus:bg-background focus:px-4 focus:py-3 focus:text-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
            >
                Skip to main content
            </a>
            <PublicHeader hasSessionHint={hasSessionHint} />
            <main id="main-content" tabIndex={-1} className="flex-1">
                {children}
            </main>
            <PublicFooter hasSessionHint={hasSessionHint} />
        </div>
    );
};

PublicLayout.propTypes = {
    children: PropTypes.node,
};

export default PublicLayout;
